import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { collection, getDocs, query, where, orderBy } from 'firebase/firestore';
import { db } from '../firebase';

const TestFirebaseConnection = () => {
  const [trips, setTrips] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const { currentUser } = useAuth();

  useEffect(() => {
    const testConnection = async () => {
      try {
        console.log('🔍 Testing Firebase connection...');
        console.log('Current user:', currentUser);

        // Test 1: Get all trips (no filter)
        const allTripsQuery = collection(db, 'trips');
        const allTripsSnapshot = await getDocs(allTripsQuery);
        const allTrips = allTripsSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        console.log('📋 All trips in database:', allTrips);

        // Test 2: Get trips for current user
        if (currentUser) {
          const userTripsQuery = query(
            collection(db, 'trips'),
            where('members', 'array-contains', currentUser.email),
            orderBy('createdAt', 'desc')
          );
          const userTripsSnapshot = await getDocs(userTripsQuery);
          const userTrips = userTripsSnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
          }));
          console.log('👤 User trips:', userTrips);
          
          // Test 3: Check if user email is in any trip members
          const tripsWithUser = allTrips.filter(trip => 
            trip.members && trip.members.includes(currentUser.email)
          );
          console.log('🔎 Trips containing user email:', tripsWithUser);
          
          setTrips(userTrips);
        }
      } catch (err) {
        console.error('❌ Firebase test error:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    testConnection();
  }, [currentUser]);

  if (loading) return <div>Testing Firebase connection...</div>;

  return (
    <div className="p-6 bg-white rounded-lg shadow">
      <h2 className="text-xl font-bold mb-4">Firebase Connection Test</h2>
      
      {error && (
        <div className="mb-4 p-3 bg-red-100 text-red-700 rounded">
          Error: {error}
        </div>
      )}

      <div className="mb-4">
        <p className="text-sm text-gray-600">
          Current User: {currentUser?.email || 'Not logged in'}
        </p>
        <p className="text-sm text-gray-600">
          Trips Found: {trips.length}
        </p>
      </div>

      <div className="space-y-2">
        <h3 className="font-semibold">Trips:</h3>
        {trips.map(trip => (
          <div key={trip.id} className="p-3 border rounded">
            <p className="font-medium">{trip.name}</p>
            <p className="text-sm text-gray-600">Members: {trip.members?.join(', ')}</p>
            <p className="text-sm text-gray-600">Created: {trip.createdAt?.toDate?.()?.toLocaleString() || 'No date'}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TestFirebaseConnection;
